@if (!isMainLayout && project) {
<div class="sidenav-header" [ngClass]="{'iconOnly': !isSidenavOpen}">

  @if (!(uiTool.isMobile$ | async)) {
  <mat-icon *ngIf="!isSidenavOpen" aria-label="Menu button" (click)="onToggleSidenav()"
    class="toggle">arrow_right</mat-icon>

  <mat-icon *ngIf="isSidenavOpen" aria-label="Menu button" (click)="onToggleSidenav()"
    class="toggle open">arrow_left</mat-icon>
  }

  <h2 class="project-title" *ngIf="isSidenavOpen" data-testid="sidenav-project-title">{{project.name}}</h2>
  <div class="com-status" *ngIf="project.status">
    <app-indicator *ngIf="project.status.communication==2">
      <span *ngIf="isSidenavOpen">{{'status.active'|translate}}</span><mat-icon>wifi</mat-icon>
    </app-indicator>

    <app-indicator *ngIf="project.status.communication==1" [color]="'danger'">
      <span *ngIf="isSidenavOpen">{{'status.inactive'|translate}}</span><mat-icon>wifi_off</mat-icon>
    </app-indicator>

    <app-indicator *ngIf="project.status.communication==1 && isSidenavOpen" [color]="'info'">
      {{'status.last'|translate}} {{ project.status.last | timeFormat:'dd/MM/yyyy HH:mm': userLanguage() }}
    </app-indicator>

    <app-indicator *ngIf="project.status.communication==0" [color]="'info'">
      <span *ngIf="isSidenavOpen">{{'status.unavailable'|translate}}</span><mat-icon>wifi</mat-icon>
    </app-indicator>

    <app-indicator *ngIf="project.status.communication==2 && isSidenavOpen" [color]="'info'">
      {{project.status.unitConnected}}/{{project.status.unitCount}}
      {{'trackers.connected'|translate}}
    </app-indicator>
  </div>

  <div *ngIf="!project.status" class="com-status">
    <app-indicator [color]="'info'">
      <span>{{'status.loading'|translate}}</span><mat-icon>wifi</mat-icon>
    </app-indicator>
  </div>

  <div class="divUserList">
    <app-socket-user-list [sidenavOpen]="isSidenavOpen"></app-socket-user-list>
  </div>
</div>

@if (!(uiTool.isMobile$ | async)) {
<div class="side-menu" [ngClass]="{expanded: isSidenavOpen}">
  <app-nested-navigation [nodes]="menuNodes" [open]="isSidenavOpen"></app-nested-navigation>
</div>
} @else {
<div class="sidenav-mobile">
  <div class="mainNode">
    <div *ngFor="let node of mainNodes" class="menu-item">

      <!-- if no children -->
      <mat-icon *ngIf="!node.children || node.children.length === 0" [routerLink]="node.route" (click)="closeSidenav()">
        {{ node.icon }}
      </mat-icon>

      <!-- if children -->
      <mat-icon *ngIf="node.children && node.children.length > 0" [matMenuTriggerFor]="childMenu">
        {{ node.icon }}
      </mat-icon>

      <mat-menu #childMenu="matMenu">
        <button mat-menu-item *ngFor="let child of node.children" [routerLink]="child.route"
          (click)="toggleSubMenuMain(node)">
          <mat-icon>{{ child.icon }}</mat-icon>
          {{ child.name | translate }}
        </button>
      </mat-menu>

    </div>
  </div>

  <div class="side-menu" [ngClass]="{expanded: isSidenavOpen}">
    <app-nested-navigation [nodes]="menuNodes" [open]="true"></app-nested-navigation>
  </div>
</div>
}

} @else {
<div class="mainLayout">
  <div *ngFor="let node of mainNodes" class="menu-item">

    <!-- Si pas d'enfants -->
    <div class="mainItem rowItem" *ngIf="!node.children || node.children.length === 0">
      <a [routerLink]="node.route" (click)="closeSidenav()">
        <mat-icon [routerLink]="node.route">
          {{ node.icon }}
        </mat-icon>
        {{ node.name | translate }}
      </a>
    </div>

    <!-- Si il y a des enfants -->
    <div class="mainItem" *ngIf="node.children && node.children.length > 0">
      <div class="menu-parent" (click)="toggleSubMenu(node)">
        <mat-icon>{{ node.icon }}</mat-icon>
        {{ node.name | translate }}
        <mat-icon>{{ node.isOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      <!-- Liste des enfants, affichée lorsque le menu est ouvert -->
      <div [@expandCollapse]="node.isOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">
        <ul *ngIf="node.isOpen || node.isOpen === false">
          <li *ngFor="let child of node.children">
            <a [routerLink]="child.route" (click)="closeSidenav()">
              <mat-icon>{{ child.icon }}</mat-icon>
              {{ child.name | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
}